import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Divider } from '@mui/material';

import ShipmentCategoryMenu from './ShipmentCategoryMenu';
import ShipmentFacilityTabs from './ShipmentFacilityTabs';
import ShipmentPresetTabs from './ShipmentPresetTabs';
import ShipmentListToolbar from './ShipmentListToolbar';
import ShipmentListTable from './ShipmentListTable';

const ShipmentsView = () => {
  const { activeCategory } = useSelector(({ shipmentModule }) => shipmentModule);

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      {/* Left: Category Menu */}
      <Box
        sx={{
          width: 240,
          minWidth: 240,
          borderRight: 1,
          borderColor: 'divider',
          overflow: 'auto',
        }}
      >
        <ShipmentCategoryMenu />
      </Box>
      {/* Right: Content Area */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        {activeCategory === 'shipped' && <ShipmentFacilityTabs />}
        {activeCategory === 'awaitingShipment' && <ShipmentPresetTabs />}
        <ShipmentListToolbar />
        <Divider />
        <ShipmentListTable />
      </Box>
    </Box>
  );
};

export default ShipmentsView;
